import React, { Component } from "react";

class ImportacaoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;

    this.setState({ consulta: consulta });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">IMPORTAÇÃO DO SISTEMA SOLUS</h4>
                <p className="card-description" />
                <div className="form-group">
                  <label>Nome do arquivo</label>
                  <input id="arquivo" type="file" name="arquivo" className="file-upload-default" onChange={this.arquivoChange} />
                  <div className="input-group col-xs-12">
                    <input id="arquivo-nome" type="text" className="form-control file-upload-info" disabled placeholder="Nome do arquivo" />
                    <span className="input-group-append">
                      <button onClick={() => this.selecionarArquivo()} className="file-upload-browse btn btn-info" type="button" >Selecionar</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ImportacaoForm;
